import styled, { css } from 'styled-components';

export const Card = styled.div`
  background: ${({ theme }) => theme.colors.greys.lightest};
  border-radius: 12px;
  box-shadow: 0 2px 8px rgb(0 0 0 / 6%);
  display: flex;
  flex-direction: column;
  height: 148px;
  padding: 20px;
  transition: box-shadow 0.2s ease;
  width: 425px;

  ${({ $isClickable }) =>
    $isClickable &&
    `
    cursor: pointer;
  `}

  &:hover {
    box-shadow: 0 4px 12px rgb(0 0 0 / 10%);
  }
`;

export const HeaderRow = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin-bottom: 16px;
`;

export const LogoAndTitle = styled.div`
  align-items: center;
  display: flex;
  gap: 12px;
`;

export const IconWrapper = styled.div`
  align-items: center;
  background-color: ${({ backgroundColor }) => backgroundColor};
  border-radius: 50%;
  color: ${({ theme }) => theme.colors.greys.lightest};
  display: flex;
  flex-shrink: 0;
  font: normal 600 14px/16px inter, sans-serif;
  height: 32px;
  justify-content: center;
  text-transform: uppercase;
  width: 32px;
`;

export const LogoImage = styled.img`
  border-radius: 8px;
  flex-shrink: 0;
  height: 32px;
  object-fit: contain;
  width: 32px;
`;

export const IntegrationStatusLabelHost = styled.div`
  flex-shrink: 0;
`;

export const IntegrationStatusBadge = styled.span`
  align-items: center;
  background-color: ${({ theme }) => theme.colors.greys.lightest};
  border-radius: 4px;
  border-style: solid;
  border-width: 2px;
  display: flex;
  font: ${({ theme }) => theme.label.font};
  min-height: 24px;
  padding: 4px 8px;
  width: fit-content;

  ${({ $status, theme }) => {
    if ($status === 'active') {
      return css`
        border-color: ${theme.colors.infoGreen};
        color: ${theme.colors.infoGreen};
      `;
    }

    if ($status === 'paused') {
      return css`
        border-color: ${theme.colors.infoRed};
        color: ${theme.colors.infoRed};
      `;
    }

    if ($status === 'coming_soon') {
      return css`
        border-color: ${theme.colors.blacks.ipBlack5};
        background-color: ${theme.colors.blacks.ipBlack5};
        color: ${theme.colors.greys.lightest};
      `;
    }

    return css`
      border-color: ${theme.colors.greys.dark};
      color: ${theme.colors.greys.darker};
    `;
  }}
`;
